import React from 'react';
import { hot } from 'react-hot-loader';
import s from './Spacer.scss';

const Spacer = ({ content, setup, inlineCategoryContent = false }) => {
	const height = parseInt(content.height, 10) || 100;
	return <div className={[s.spacer, (inlineCategoryContent ? s.spacer__inlineCategoryContent : null)].join(' ')} style={{ height: `${setup.breakPoint === 'mobile' ? height / 2 : height}px` }} />;
};

export default hot(module)(Spacer);
